import React from 'react'
import styled, { css } from 'styled-components'


const Btn = styled.button`
  padding: 10px 10px;
  font: 16px 'Inter', sans-serif;
  border-radius: 3px;
  border: 1px solid #D9D9D9;
  background: #F5F5F5;
  color: #374151;
  cursor: pointer;
  transition: all .15s;

  ${({ active }) => active && css`
    background: #28AAE1;
    border-color: #28AAE1;
    color: #fff;
  `}
`
const Group = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`

export default function YesNoInput ({ value, onChange }) {
  return (
    <Group>
      <Btn
        type="button"
        active={value === 'nao'}
        onClick={() => onChange('nao')}
      >
        Não
      </Btn>
      <Btn
        type="button"
        active={value === 'sim'}
        onClick={() => onChange('sim')}
      >
        Sim
      </Btn>
    </Group>
  )
}
